<p-card class="p-card container">
  <h3 i18n>Mot de passe</h3>

  <form class="flex-column flex" [formGroup]="form">
    <div class="layout__inner-card mb-3">
      <label class="label-top" for="currentPassword" i18n>Mot de passe actuel</label>
      <input
        [ngClass]="{
          'ng-dirty margin--none': isIncorrectPasswordError,
          'mb-2': !isIncorrectPasswordError,
        }"
        formControlName="currentPassword"
        [feedback]="false"
        id="currentPassword"
        type="password"
        pPassword />
      @if (isIncorrectPasswordError) {
        <p class="mt-2 text-red-500" i18n>Le mot de passe ne correspond pas au mot de passe actuel</p>
      }

      <label class="label-top" for="newPassword" i18n>Nouveau mot de passe</label>
      <input
        class="mb-2"
        formControlName="newPassword"
        [feedback]="false"
        id="newPassword"
        type="password"
        pPassword />

      <div class="mb-4 flex flex-row gap-3">
        <div>
          <div
            class="align-items-baseline flex gap-1"
            [ngClass]="{
              'text-600': hasPasswordError('minLength8Invalid'),
              'text-green-600': !hasPasswordError('minLength8Invalid'),
            }">
            <i class="pi pi-check mr-1 mt-1"></i>
            <span i18n>8 caractères minimum</span>
          </div>

          <div
            class="align-items-baseline flex gap-1"
            [ngClass]="{
              'text-600': hasPasswordError('containsLowerCaseInvalid'),
              'text-green-600': !hasPasswordError('containsLowerCaseInvalid'),
            }">
            <i class="pi pi-check mr-1 mt-1"></i>
            <span i18n>Au moins une minuscule</span>
          </div>
        </div>

        <div class="flex-column flex">
          <div
            class="align-items-baseline flex gap-1"
            [ngClass]="{
              'text-600': hasPasswordError('containsUpperCaseInvalid'),
              'text-green-600': !hasPasswordError('containsUpperCaseInvalid'),
            }">
            <i class="pi pi-check mr-1 mt-1"></i>
            <span i18n>Au moins une majuscule</span>
          </div>

          <div
            class="align-items-baseline flex gap-1"
            [ngClass]="{
              'text-600': hasPasswordError('containsNumberInvalid'),
              'text-green-600': !hasPasswordError('containsNumberInvalid'),
            }">
            <i class="pi pi-check mr-1 mt-1"></i>
            <span class="rules__desc" i18n>Au moins un chiffre</span>
          </div>
        </div>
      </div>

      <label class="label-top" for="confirmNewPassword" i18n>Confirmer le nouveau mot de passe</label>
      <input
        formControlName="confirmNewPassword"
        [feedback]="false"
        id="confirmNewPassword"
        type="password"
        pPassword />
      @if (isSuccess) {
        <p class="text-green-600" i18n>Le mot de passe a été modifié avec succès</p>
      }
      @if (form.hasError('passwordConfirmationInvalid') && form.controls.confirmNewPassword.touched) {
        <p class="error" i18n>Les mots de passe doivent correspondre</p>
      }
      @if (isPasswordTooWeakError) {
        <p class="text-red-500" i18n>le mot de passe est trop faible</p>
      }
    </div>
  </form>

  <p-button
    class="flex justify-content-end"
    [loading]="isLoading"
    [disabled]="form.invalid"
    (onClick)="updatePassword()"
    i18n-label
    label="Réinitialiser mon mot de passe"
    icon="pi pi-sync"></p-button>
</p-card>
